import { AsyncPipe, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { map } from 'rxjs';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { FeatureFlagFacade } from 'src/app/core/state/facades/feature-flag.facade';
import { FeatureFlagEnum } from 'src/app/shared/enums/feature-flag.enum';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { VerifiedWorkerBadgeModalComponent } from './verified-worker-badge-modal/verified-worker-badge-modal.component';

const LABELS = {
  small: '',
  large: 'Verified',
};

@Component({
  selector: 'app-verified-worker-badge',
  standalone: true,
  templateUrl: './verified-worker-badge.component.html',
  styleUrls: ['./verified-worker-badge.component.scss'],
  imports: [AsyncPipe, IonicModule, NgIf, VerifiedWorkerBadgeModalComponent],
})
export class VerifiedWorkerBadgeComponent {
  @Input() set size(value: keyof typeof LABELS) {
    this.label = LABELS[value];
  }

  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

  label: string = LABELS.small;

  isModalOpen = false;

  isEnabled$ = this.featureFlagFacade
    .isFeatureEnabled$([FeatureFlagEnum.MARKETPLACE_VERIFIED_WORKER_BADGE])
    .pipe(map((flags) => flags[FeatureFlagEnum.MARKETPLACE_VERIFIED_WORKER_BADGE] ?? false));

  constructor(
    private readonly featureFlagFacade: FeatureFlagFacade,
    public utilityService: UtilityService,
    private analyticsService: AnalyticsService,
  ) {}

  handleClick(): void {
    this.isModalOpen = true;
    this.analyticsService.clicked({
      object_type: 'Button',
      object_target: 'Verified Worker Badge',
    });
    this.onClick.emit();
  }

  dismissModal(): void {
    this.isModalOpen = false;
  }
}
